module.exports = __webpack_public_path__ + "static/Dona-Medium-087aa774e08574361fd03c4408f80258.eot";